import {JourneyModel} from "./journey.model";
import {BookingEntityStorage} from "../storage/booking-entity-storage";
import {JourneySessionStorageKeys} from "./journey-session-storage-keys";
import {BookingSessionStorageKeys} from "../storage/booking-session-storage-keys";



export class JourneySessionStorage extends BookingEntityStorage<JourneySessionStorageKeys> {

    constructor(journey: JourneyModel) {
       super({
           parentStorage: journey.booking.storage,
           parentStorageKey: BookingSessionStorageKeys.journeyStorage,
           getStorageDiscriminator: () => journey.journeyKey
       })
    }
}
